import * as React from "react";
import {RestDataLoader} from "../dashboard/widgets/unilever/RestDataLoader";

export type JSONList<T> = {
    list: T[]
};

export enum RestDataStatus {
    LOADING,
    LOADED,
    ERROR
}

interface RestDataState<D, E = any> {
    data?: D;
    error?: E;
    status: RestDataStatus;
}

export interface RestDataResponse<D, P, E> {
    data?: D;
    error?: E;
    status: RestDataStatus;
    reload: (params?: P) => void;
}

interface UseRestDataOptions<D> {
    withAuthentication?: boolean;
    immediate?: boolean,
    mapResult?: (x: any) => D
}

// todo add dependencies for dependencies based reload
// todo add option for no initial load

export default function useRestData<D = any, P = any, E = any>(url: string, params: P = {} as any, options : UseRestDataOptions<D> = {}): RestDataResponse<D, P, E> {

    const [state, setState] = React.useState<RestDataState<D, E>>({ status: RestDataStatus.LOADING });

    const loadData = (p = params) => {

        setState({ status: RestDataStatus.LOADING });

        RestDataLoader.loadData(
            url,
            p,
            data => {
                setState({
                    data: (options.mapResult ?? (x => x))(data),
                    status: RestDataStatus.LOADED,
                });
            },
            (error => {
                setState({status: RestDataStatus.ERROR, error});
            }) as any,
            options.withAuthentication ?? true
        );
    };

    React.useEffect(() => {
        if (options.immediate !== false) {
            loadData();
        }
    }, [url]);

    return { ...state, reload: loadData };
}